<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <RangeDatePickerMenu
                dense
                hide-details
                v-model="requestsInterval"
                label="Dates Interval"
                showButtons
                @onOkClick="getRequestsList"
              />
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                dense
                hide-details
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
              ></v-text-field>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="headers.length">
              <h3>Groups to show:</h3>
              <div
                class="px-2 d-inline-block"
                v-for="(group, groupKey) in headers"
                :key="groupKey"
              >
                <v-switch
                  dense
                  :label="group.groupName"
                  v-model="group.show"
                  @change="switchGroup(group, $event)"
                ></v-switch>
              </div>
              <v-divider></v-divider>
              <v-data-table
                dense
                fixed-header
                class="data-table"
                mobile-breakpoint="0"
                :height="tableHeight"
                :search="search"
                :headers="subHeaders"
                :items="filteredEmployeeRequests"
                :items-per-page="50"
                :footer-props="{
                  'items-per-page-options': [10, 30, 50, -1]
                }"
              >
                <template v-slot:header>
                  <thead class="sticky-group-header">
                  <tr>
                    <th
                      class="group-header"
                      :colspan="1"
                    >
                    </th>
                    <th
                      v-for="(gr, grKey) in groupHeaders"
                      :key="grKey"
                      :colspan="4"
                      class="group-header"
                    >
                      <v-btn
                        small
                        color="primary"
                        text
                        @click="openGroup(gr)"
                      >
                        {{ gr.groupName }}
                      </v-btn>
                    </th>
                  </tr>
                  </thead>
                </template>
                <template
                  v-for="(itm, itmKey) in subHeaders"
                  v-slot:[`item.${itm.value}`]="{ item, header }"
                >
                  <span
                    :key="itmKey + 'Full_Name'"
                    v-if="header.groupId === -1"
                  >
                    {{ item[itm.value] }}
                  </span>
                  <div
                    :key="itmKey"
                    v-else
                    @click="onRowClick(item, header)"
                    :class="{'row-item': item[itm.value] || item[itm.value] === 0}"
                  >
                    <span>{{ item[itm.value] }}</span>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text class="text-center" v-else>No result</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <RequestsMenu
      v-if="showRequestsMenu"
      v-model="showRequestsMenu"
      :rowItem="selectedRowItem"
      :selectedColumn="selectedColumn.groupName"
      :tabTitles="groupHeaders"
      :headers="headers"
      :requestsInterval="requestsInterval"
      :allEmployeeMode="allEmployeeMode"
      @requestWasChanged="recalculateGroup"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'Requests',
  components: {
    RequestsMenu: () => import('@/components/requests/RequestsMenu'),
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  data () {
    return {
      allEmployeeMode: false,
      requestsInterval: [
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      selectedRowItem: null,
      selectedColumn: null,
      showRequestsMenu: false,
      search: null,
      employeeRequests: [],
      hoveredColumn: null,
      nestedHeaders: [],
      headers: []
    }
  },
  mounted () {
    this.getRequestsList()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    employeeRoles () {
      return this.$store.getters.getEmployeeRoles
    },
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? 'calc(100vh - 500px)' : 'calc(100vh - 390px)'
    },
    groupHeaders () {
      return this.headers.filter(header => header.show === true)
    },
    filteredEmployeeRequests () {
      const skipKeys = ['name', 'userUuid', 'Full_Name']

      const activeValueKeys = this.subHeaders
        .filter(h => h.value && !skipKeys.includes(h.value))
        .map(h => h.value)

      return this.employeeRequests.filter(emp =>
        activeValueKeys.some(key => {
          const value = emp[key]
          return Boolean(value)
        })
      )
    },
    subHeaders () {
      this.nestedHeaders.forEach(header => {
        if (header.groupId === -1) {
          header.divider = true
          header.width = 200
          header.class = 'fixed-column-header text-no-wrap'
          header.cellClass = 'fixed-column-rows text-no-wrap'
        } else {
          if (header.text === 'Approved') {
            header.divider = true
          }
          header.width = 80
          header.align = 'center'
          header.class = 'text-no-wrap px-1 sticky-header'
          header.cellClass = 'text-no-wrap px-0'
        }
      })
      return this.nestedHeaders.filter(header => header.show === true)
    }
  },
  methods: {
    recalculateGroup (event) {
      const rowItem = this.employeeRequests.find(el => el.Employee_ID === event.requestOwner)
      if (event.group === 'Benefit') {
        rowItem.Benefit_Pending--
        rowItem[`${event.subCategory}_Pending`]--
        if (event.approved) {
          rowItem.Benefit_Approved++
          rowItem[`${event.subCategory}_Approved`]++
        } else if (!event.approved) {
          rowItem.Benefit_Rejected++
          rowItem[`${event.subCategory}_Rejected`]++
        }
      } else if (event.group === 'L&D') {
        rowItem['L&D_Pending']--
        if (event.approved) {
          rowItem['L&D_Approved']++
        } else if (!event.approved) {
          rowItem['L&D_Rejected']++
        }
      } else if (event.group === 'Sick Leave') {
        rowItem['Sick Leave_Pending']--
        if (event.approved) {
          rowItem['Sick Leave_Approved']++
        } else if (!event.approved) {
          rowItem['Sick Leave_Rejected']++
        }
      } else if (event.group === 'Sport') {
        rowItem.Sport_Pending--
        if (event.approved) {
          rowItem.Sport_Approved++
        } else if (!event.approved) {
          rowItem.Sport_Rejected++
        }
      } else if (event.group === 'Medical Insurance') {
        rowItem['Medical Insurance_Pending']--
        if (event.approved) {
          rowItem['Medical Insurance_Approved']++
        } else if (!event.approved) {
          rowItem['Medical Insurance_Rejected']++
        }
      } else if (event.group === 'Refund') {
        rowItem.Refund_Pending--
        if (event.approved) {
          rowItem.Refund_Approved++
        } else if (!event.approved) {
          rowItem.Refund_Rejected++
        }
      }
    },
    switchGroup (group, e) {
      this.nestedHeaders.forEach(header => {
        if (header.groupId === group.groupIndex) {
          header.show = e
        }
      })
    },
    openGroup (group) {
      this.allEmployeeMode = true
      this.selectedColumn = group
      this.selectedRowItem = null
      this.showRequestsMenu = true
    },
    onRowClick (item, header) {
      this.allEmployeeMode = false
      const activeGroup = this.groupHeaders.find(el => el.groupIndex === header.groupId)
      this.selectedRowItem = item
      this.selectedColumn = activeGroup
      this.showRequestsMenu = true
    },
    getRequestsList () {
      if (this.requestsInterval.length !== 2 || this.requestsInterval[0].length !== 10 || this.requestsInterval[1].length !== 10) {
        this.requestsInterval = [
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ]
      }
      this.axios.get(`/api/requests/list-of-empl-and-req/${this.requestsInterval[0]}/${this.requestsInterval[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.headers = res.data[0]
        this.nestedHeaders = res.data[1]
        this.employeeRequests = res.data[2]
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.data-table {
  &::v-deep {
    tr {
      th, td {
        background-color: inherit;
        border: 0;
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
        td {
          background-color: rgba(0, 0, 0, 0.04) !important;
        }
      }
    }

    .fixed-column-header {
      position: sticky;
      left: 0;
      top: 32px;
      z-index: 2;
    }

    .fixed-column-rows {
      position: sticky;
      left: 0;
      z-index: 1;
      background-color: #fff;
    }

    .sticky-header {
      position: sticky;
      top: 32px;
      z-index: 1;
    }

    .sticky-group-header {
      position: sticky;
      z-index: 3;
      top: 0;
    }

    .group-header {
      border-right: thin solid rgba(0, 0, 0, 0.12);
      text-align: center !important;
      cursor: default;
    }
  }
}

.theme--dark {
  .data-table {
    &::v-deep {
      .fixed-column-rows {
        background-color: #1e1e1e !important;
      }

      .group-header {
        border-right-color: rgba(255, 255, 255, 0.12);
      }
      tr {
        &:hover {
          background-color: rgba(255, 255, 255, 0.08);
          td {
            background-color: rgba(255, 255, 255, 0.08) !important;
          }
        }
      }
    }
  }
}

.row-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer !important;
  &:hover {
    border: 1px solid currentColor !important;
    background: rgba(0, 0, 0, 0.04);
  }
}

.theme--dark .row-item:hover {
  background: rgba(255, 255, 255, 0.08);
}
</style>
